/**
 * Role-related translations for Spanish language
 * This file contains translations for role names and descriptions
 */
export default {
  roles: {
    merlin: 'Merlín',
    merlinPure: 'Merlín Puro',
    guinevere: 'Ginebra',
    percival: 'Percival',
    tristan: 'Tristán',
    isolde: 'Isolda',
    troublemaker: 'Problematizador',
    servant: 'Servidor',
    goodLancelot: 'Lancelot Bueno',
    evilLancelot: 'Lancelot Malvado',
    lancelots: 'Lancelotes',
    mordred: 'Mordred',
    trickster: 'Tramposo',
    morgana: 'Morgana',
    oberon: 'Oberón',
    lunatic: 'Lunático',
    brute: 'Bruto',
    minion: 'Secuaz',
    witch: 'Bruja',
    cleric: 'Clérigo',
    revealer: 'Revelada',
    role: 'Rol',
    unknown: 'Rol desconocido',
    mysteryWizard: 'Mago misterioso',
    unknownLancelot: 'Lancelot desconocido',
    wraith: 'Espectro',
  },
  rolesInfo: {
    roles: 'Roles',
    inGameRoles: 'Roles en el juego',
    visibleRoles: 'Roles visibles para ti',
    merlinInfo: 'Conoce a los malvados, debe permanecer oculto',
    merlinPureInfo: 'Conoce a los malvados y sus roles, debe permanecer oculto',
    percivalInfo: 'Conoce a dos magos (Merlín y Morgana), pero no sabe quién es quién',
    servantInfo: 'Sirviente leal de Arturo',
    troublemakerInfo: 'Obligado a mentir sobre su lealtad',
    guinevereInfo: 'Conoce a dos Lancelots pero no conoce su lealtad',
    goodLancelotInfo: 'Lancelot bueno, puede cambiar su rol a malvado en el juego',
    evilLancelotInfo: 'Lancelot malvado, puede cambiar su rol a bueno en el juego',
    mordredInfo: 'Desconocido para Merlín',
    morganaInfo: 'Aparece como Merlín para Percival',
    oberonInfo: 'Desconocido para los Malvados',
    minionInfo: 'Esbirro de Mordred',
    isoldeInfo: 'Amante. Conoce a Tristán, debe permanecer oculta',
    tristanInfo: 'Amante. Conoce a Isolda, debe permanecer oculto',
    evilInfo: 'Jugador malvado con un rol desconocido',
    goodInfo: 'Jugador bueno con un rol desconocido',
    tricksterInfo: 'Mintiendo sobre su lealtad',
    lunaticInfo: 'Debe fallar en todas las misiones',
    bruteInfo: 'Solo puede fallar en las tres primeras misiones',
    witchInfo:
      'Puede ocultar el resultado de una misión, pero esto dará una verificación de lealtad a un jugador aleatorio',
    revealerInfo: 'Revelarse después de la segunda misión fallida',
    clericInfo: 'Conoce la lealtad del líder de la primera misión. Debe permanecer oculto',
    unknownInfo: 'Rol desconocido',
    mysteryWizardInfo: 'Uno de los dos magos es bueno (Merlín) o malo (Morgana)',
    unknownLancelotInfo: 'Lancelot, cuya lealtad es desconocida',
    wraithInfo: 'Desconocido para los Malvados y Merlín',
  },
};
